import React from "react";
import { useNode, Element } from "@craftjs/core";

export const AccordionContainer = ({ children }) => {
  const {
    connectors: { connect, drag },
  } = useNode();

  return (
    <div 
      style={{minHeight:'10vh', opacity:1}} 
      ref={(ref) => connect(drag(ref))}
      onClick={(e) => e.stopPropagation()} // Prevent clicks from bubbling to accordion header
    >
      {children}
    </div>
  );
};


AccordionContainer.craft = {
  rules: {
    canDrag: () => false, // Prevent dragging the container itself
  },
};

export default AccordionContainer;
